import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";

// import { Merchant } from '../../_models';
import { AlertService, DealService } from "../../_services";

@Component({ templateUrl: "deal.redeem.html" })
export class DealRedeem implements OnInit, OnDestroy {
  heading = "Deals Redeem Details";
  subheading = "";
  icon = "fa fa-tags icon-gradient bg-happy-itmeo";
  link = "/deal/add";
  redeem = "/deal/redeem";
  merchants: [];
  dataSource: MatTableDataSource<any[]>;
  search_key = "";
  pageSizeOptions = null;

  displayedColumns = [
    "s_no",
    "name",
    "email",
    "deal_name",
    "coin",
    "created_on"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(",").map(str => +str);
  }

  constructor(
    private dealServices: DealService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.loadAllDeals();
  }

  ngOnDestroy() {}

  clearFilters() {
    this.dataSource.filter = "";
    this.search_key = "";
  }

  private loadAllDeals() {
    this.dealServices
      .getAllRedeem()
      .pipe(first())
      .subscribe((deals: any) => {
        if (deals.status == "ok") {
          this.dataSource = new MatTableDataSource(deals.result_set);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }

  deleteDeal(id: number) {
    this.alertService.delete().then(data => {
      if (data) {
        this.dealServices
          .delete(id)
          .pipe(first())
          .subscribe((data: any) => {
            if (data.status == "ok") {
              this.alertService.success(data.message, true);
              this.loadAllDeals();
            } else {
              this.alertService.error(data.message, true);
            }
          });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
